import { render, staticRenderFns } from "./IronIcon.vue?vue&type=template&id=600d7255&"
import script from "./IronIcon.vue?vue&type=script&lang=js&"
export * from "./IronIcon.vue?vue&type=script&lang=js&"
import style0 from "./IronIcon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports